'use strict';


import {threeJsVariables, UIRoot} from '../../../settings';
import {BaseElement} from "../../interfaces/BaseElement";

// const popup = createHtmlElement(UIRoot,'','div',['public-layer-popup','hidden']);

export class Popup {

    constructor () {
        this.popup = new BaseElement()
            .addClass('public-layer-popup','hidden')
            .appendTo(UIRoot);
    }

    showPopup() {
        // this.popup.style.left = threeJsVariables.mouse.winX + 'px';
        // this.popup.style.top = threeJsVariables.mouse.winY + 'px';
        // this.popup.classList.remove('hidden');
        this.popup
            .addStyle('left', threeJsVariables.mouse.winX + 'px')
            .addStyle('top', threeJsVariables.mouse.winY + 'px')
            .removeClass('hidden');
    }

    hidePopup() {
        // this.popup.style.left = '';
        // this.popup.style.top = '';
        // this.popup.classList.add('hidden');
        this.popup
            .addStyle('left', '')
            .addStyle('top', '')
            .addClass('hidden');
    }

    updatePopupPosition() {
        if (!this.popup.DOMElement.classList.contains('hidden')){
            // this.popup.style.left = threeJsVariables.mouse.winX + 'px';
            // this.popup.style.top = threeJsVariables.mouse.winY + 'px';
            this.popup
                .addStyle('left', threeJsVariables.mouse.winX + 'px')
                .addStyle('top', threeJsVariables.mouse.winY + 'px');
        }
    }

    set popupContent(content) {
        while (this.popup.DOMElement.firstElementChild) {
            this.popup.DOMElement.firstElementChild.remove();
        }
        this.popup.innerHtml(content);
    }
}